import React from "react";

const DatePicker = ({
  placeholder,
  Value,
  handleInput,
  height,
  isPast,
  isFuture,
  isPastValue,
  isFutureValue,
  disabled
}) => {
  const today = new Date().toISOString().split("T")[0];
  return (
    <div className="date-input-container wrapper ">
      <input
        type="date"
        disabled={disabled ? disabled : false}
        style={{
          height: height ? height : "50px",
          width: "100%",
          borderRadius: "11px",
          border: "1px solid #666666",
          padding: "3%",
          backgroundColor:"#FFFFFF",
          fontFamily:"PoppinsMedium",
          outline:"none"
        }}
        placeholder={placeholder ? placeholder : "MM/DD/YYYY"}
        min={isPast ? today : isPastValue ? isPastValue : ""}
        max={isFuture ? today : isFutureValue ? isFutureValue : ""}
        value={Value}
        onChange={(e) => handleInput(e.target.value)}
      />
      <span></span>
      
    </div>
  )
};

export default DatePicker;
